import React, { FC } from 'react';
import Modal from '@common/modal';
import {
  useTutorialTermsCheckNew,
  useTermsAgreeForSn,
  applyTermsCheckNewKeys,
} from '@repository/userTermsAgrees/useUserTermsAgrees';
import { useTermsOne } from '@repository/terms/useTerms';
import { useUserInfo } from '@repository/auth/useUserInfo';
import useDebounce from '@utils/hooks/useDebounce';
import { queryClient } from '@utils/queryClient';

import classnames from 'classnames/bind';
import styles from './tutorialTerms.module.scss';
const cx = classnames.bind(styles);

interface ITutorialTermsModalProps {
  visible: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

const TutorialTermsModal: FC<ITutorialTermsModalProps> = ({ visible, onConfirm, onClose }) => {
  const { data: userData } = useUserInfo();
  const isLogin = !!userData?.id;

  const { data, isFetched } = useTutorialTermsCheckNew(isLogin);
  const { data: tutorialTermsData } = useTermsOne(data?.termsSn, isFetched);

  const { mutateAsync: termsAgreeMutateAsync } = useTermsAgreeForSn();

  const onSubmit = useDebounce(async () => {
    if (!tutorialTermsData) return;

    const result = await termsAgreeMutateAsync(tutorialTermsData.sn);

    if (result) {
      await queryClient.refetchQueries(applyTermsCheckNewKeys, { active: true });
      onConfirm();
    }
  }, 500);

  return (
    <Modal visible={visible} dimmed={true}>
      <div className={cx('layerTerms')}>
        <strong className={cx('title')}>개인정보 수집 및 이용 동의</strong>

        <div className={cx('termsArea')}>
          <div className={cx('termsWrap')}>
            <div
              className={cx('termsText')}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: tutorialTermsData?.contents ?? '',
              }}
            />
          </div>
        </div>

        <a className={cx('btnAgreement')} role="button" onClick={onSubmit}>
          동의하고 시작하기
        </a>

        <a className={cx('btnClose')} role="button" onClick={onClose}>
          <span className={cx('hidden')}>close</span>
        </a>
      </div>
    </Modal>
  );
};

export default TutorialTermsModal;
